import { AxiosResponse } from 'axios'

import ClientSDK from '../../../../../App/ClientSDK'
import {
    IApiProductBrand,
    IProductBrand,
} from '../../../../../Product/DataStore/IProductBrand'

export class SecondClient {
    static getProductBrands = (): Promise<IProductBrand[]> => {
        return ClientSDK.instance()
            .get('product-brands')
            .then((response: AxiosResponse<IApiProductBrand[]>) => {
                return response.data
            })
    }
}
